export const pl = {
  navigation: {
    map: "Mapa",
    guessr: "Guessr",
  },
  home: {
    filters: "Filtry",
    general: "Ogólne",
    filterItems: {
      FAST_TRAVEL: "Szybka podróż",
      NEXT_CS: "Następne zawody",
      GUESSR: "Lokacje SSO Guessr",
    },
    coordinates: "X: {x}, Y: {y}",
  },
  guessr: {
    title: "SSO Guessr",
    loading: "Ładowanie...",
    buttons: {
      guess: "Zgadnij",
      next: "Dalej",
      again: "Jeszcze raz",
      leaveConfirm: "Gra jest w toku. Czy na pewno chcesz wyjść?",
    },
    toasts: {
      zeroPoints: "😥 Zupełnie nie tak... 0 punktów",
      goodPoints: "👍 Nieźle! Zdobywasz {points} punktów!",
      perfectPoints: "💕 PERFEKCYJNIE! {points} PUNKTÓW!",
      fetchError: "Błąd pobierania danych: {message}",
    },
    alt: {
      locationPhoto: "Zdjęcie lokacji, zgadnij gdzie zostało zrobione",
      fullscreenPreview: "Duży podgląd zdjęcia",
      clickToEnlarge: "Kliknij zdjęcie, aby powiększyć",
      tapToEnlarge: "Dotknij zdjęcie, aby powiększyć",
    },
    result: {
      perfect: [
        "Gratulacje! Jesteś prawdziwą mistrzynią lokalizacji!",
        "Perfekcja! Twoja znajomość Jorviku jest imponująca.",
        "Wyjątkowa pamięć! Masz świetne oko do szczegółów.",
        "Brawo! Rozpoznałaś każdą lokację bezbłędnie!",
      ],
      almostPerfect: [
        "Fantastycznie! Jesteś niemal mistrzynią w rozpoznawaniu lokacji.",
        "Praktycznie idealnie! Jeszcze tylko kilka detali do poprawy.",
        "Imponujące! Tylko drobne poprawki dzielą Cię od perfekcji.",
        "Świetnie! Jesteś na bardzo wysokim poziomie.",
        "Niewiele zabrakło do perfekcyjnego wyniku!",
      ],
      great: [
        "Świetna robota! Już prawie jesteś ekspertką.",
        "Bardzo blisko! Kilka drobnych poprawek i będziesz w czołówce.",
        "Czujesz się pewnie? Jeszcze chwila i będziesz najlepsza!",
        "Bardzo dobrze! Pozostało tylko kilka szczegółów do dopracowania.",
      ],
      good: [
        "Nieźle, ale możesz zrobić to lepiej!",
        "Blisko, ale jeszcze trochę pracy przed Tobą.",
        "Kilka kroków do przodu i będziesz mistrzynią!",
        "Zaczynasz się rozkręcać. Kontynuuj w tym kierunku!",
      ],
      sad: [
        "Nie poszło Ci najlepiej. Spróbuj jeszcze raz!",
        "Rozejrzyj się po Jorviku i wróć oświecona...",
        "Nie gubisz się we własnym domu z taką pamięcią?",
        "Ojej, to nie jest najlepszy wynik. Może następnym razem pójdzie lepiej?",
        "Nie zrażaj się! Każda próba przybliża Cię do celu.",
        "Wygląda na to, że potrzebujesz jeszcze trochę treningu.",
        "Nie martw się, nawet najlepsi zaczynali od zera!",
      ],
    },
    footer: {
      author: "Łukasz Skabowski",
      source: "Kod źródłowy",
    },
  },
  fastTravel: {
    HERMITS_COTTAGE: "Chatka Hermita",
    DRUID_PADDOCK: "Druidzki wybieg",
    DUNDULL: "Dundull",
    SILVERGLADE_MANOR: "Dwór Srebrnej Polany",
    JASPERS_PUMPKIN_FARM: "Dyniowa Farma Jaspera",
    STORMGARDEN: "Farma Burza",
    SOUTH_HOOF_FARM: "Farma Południowego Kopyta",
    SUNFIELD_FARM: "Farma Słonecznikowych Pól",
    STEVES_FARM: "Farma Steve'a",
    FORT_PINTA: "Fort Pinta",
    BIRKS_GRANGE: "Gospodarstwo Birka",
    JARLAHEIM: "Jarlaheim",
    VALEDALE_LAKE: "Jezioro Valedale",
    SPYMASTERS_HIDEOUT: "Kryjówka Mistrza Szpiegowania",
    CRESCENT_MOON_VILLAGE: "Księżycowy Sierp",
    ICENGATE: "Lodowy Portal",
    SILVERGLADE_VILLAGE: "Miasteczko Srebrnej Polany",
    REDWOOD_POINT: "Posterunek Sekwoi",
    STARSHINE_RANCH: "Ranczo Starshine",
    MOORLAND_STABLES: "Stajnia Moorland",
    NEW_HILLCREST_STABLES: "Stajnia Nowej Grani",
    GOLDENLEAF_STABLES: "Stajnia Złotych Liści",
    MARLEYS_VINTAGE_BARN: "Stodoła klasyki Marleya",
    BARONESS_RACETRACK: "Tor wyścigowy Baronowej",
    RIDING_ARENA: "Ujeżdżalnia",
    FIRGROVE_VILLAGE: "Wioska Jodłowy Gaj",
    TAILTOP_VILLAGE: "Wioska Pięknego Ogona",
    VALEDALE_VILLAGE: "Wioska Valedale",
    PADDOCK_ISLAND: "Wyspa Padok",
    NILMERS_HIGHLAND: "Wzgórze Nilmera",
    CAPE_WEST_FISHING_VILLAGE: "Zachodni Przylądek",
    WOLF_HALL_INN: "Zajazd pod Wilkiem",
    THE_FORGOTTEN_FIELDS: "Zapomniane Pola",
    FORT_PINTA_BEACH: "Plaża Fortu Pinta",
    MEDIEVAL_CAMP: "Średniowieczny obóz",
    NIC_STONEGROUNDS_CAMP: "Obozowisko Nica Stoneground",
    THE_EVERWIND_FIELDS: "Pola Everwind",
  },
  championships: {
    moorland: "Moorland",
    pinta: "Fort Pinta",
    silversong: "Mistrzostwa kucyków Silversong",
    baron: "Mistrzostwa baronowej",
    gold: "Dolina Złotych Wzgórz",
    jorvik: "Stajnia Jorvik",
    silver: "Srebrna Polana",
    grove: "Jodłowy Gaj",
    gran: "Nowa Grań",
    valedale: "Valedale",
  },
  time: {
    minutesSeconds: "za {minutes}min {seconds}s",
    seconds: "za {seconds}s",
  },
};
